var _defs, _path, _path2, _path3, _path4, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaxations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#b7b7b7;}.cls-2{font-size:3.76px;font-family:Avenir-Black, Avenir;font-weight:800;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.08,11.34c-1.4,0-2.74,0-4.08,0A1.14,1.14,0,0,0,7.78,12a.54.54,0,0,1-1,0,1.11,1.11,0,0,0-1.15-.65c-1.37,0-2.73,0-4.15,0V2.9c1.86-.35,4.91-.12,5.55.31A19,19,0,0,1,9.3,2.83c1.24-.06,2.48,0,3.78,0ZM2.42,3.71v6.66c1.66.33,3.39-.42,4.89.58,1.54-1,3.28-.23,4.87-.59V3.71c-1.19,0-2.34,0-3.48,0a1.29,1.29,0,0,0-.83.49c-.41.52-.74.52-1.14,0a1.29,1.29,0,0,0-.83-.49C4.76,3.68,3.61,3.71,2.42,3.71Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.71,5.55v.8H6.9v-.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.9,7.33h.81v.83H6.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.71,9.14v.8H6.9v-.8Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(8.91 8.59)"
  }, "$")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxations);
export default __webpack_public_path__ + "static/media/taxations.518e767dd0ef93e72400ee229cbfb87d.svg";
export { ForwardRef as ReactComponent };